import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=10dd78a1&scoped=true&"
import script from "./Conference.vue?vue&type=script&lang=ts&"
export * from "./Conference.vue?vue&type=script&lang=ts&"
import style0 from "./Conference.vue?vue&type=style&index=0&id=10dd78a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd78a1",
  null
  
)

export default component.exports